/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
// BASE Components
import BASESvgIcon from '../../../../@BASE/core/BASESvgIcon';
// Material UI
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Typography from '@mui/material/Typography';

import ProgressIndicators from '../../../shared-components/cards/snapshots/ProgressIndicators';
import CommentsOverview from '../../../shared-components/cards/snapshots/CommentsOverview';

function ContentListItemContentCompressed({ instance, resource, commentView, handleCommentViewChange, commentSummary, productionCommentSummary }) {

  return (
    <CardContent className="flex flex-col flex-auto lg:flex-row gap-24 p-24">
      <div className='w-full'>
        <div className='flex flex-row items-center mb-24 hidden lg:flex'>
          <BASESvgIcon size={24} color="primary">heroicons-outline:document-text</BASESvgIcon>
          <div className='ml-8 flex flex-col'>
            <Typography 
              variant='subtitle2'
              sx={{
                color: 'text.secondary',
                fontWeight: 'normal'
              }}
            >
              {instance.label}
            </Typography>
            <Typography
              variant='body1'
              sx={{
                color: 'text.normal',
                fontWeight: 'bold'
              }}
            >
              {instance.title}
            </Typography>
          </div>
        </div>
        <div className='flex flex-row items-center mb-16'>
          <BASESvgIcon className="mr-8" size={20}>
            heroicons-outline:chart-square-bar
          </BASESvgIcon>
          <Typography className="text-lg font-medium tracking-tight leading-6 truncate">
            Status
          </Typography>
        </div>
        <ProgressIndicators instance={instance} />
      </div>
      <div className='w-full'>
        <div className='flex flex-row items-center mb-0'>
          <BASESvgIcon className="mr-8" size={20}>
            heroicons-outline:chat-alt-2
          </BASESvgIcon>
          <Typography className="text-lg font-medium tracking-tight leading-6 truncate">
            Comments
          </Typography>
        </div>
        <TabContext value={commentView}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList 
              onChange={handleCommentViewChange}
              aria-label="Comment Counts"
              textColor="secondary"
              indicatorColor="secondary"
              variant="fullWidth"
            >
              <Tab label={<><BASESvgIcon className="mr-4" size={16}>heroicons-outline:document-text</BASESvgIcon><span className="font-medium text-md">Storyboard</span></>} value="storyboard" classes={{ root: 'flex-row' }} />
              <Tab label={<><BASESvgIcon className="mr-4" size={16}>heroicons-outline:desktop-computer</BASESvgIcon><span className="font-medium text-md">Production</span></>} value="production" classes={{ root: 'flex-row' }} />
            </TabList>
          </Box>
          <TabPanel value="storyboard" classes={{ root: 'p-0 pt-8' }}>
            <CommentsOverview commentSummary={commentSummary} resource={resource} />
          </TabPanel>
          <TabPanel value="production" classes={{ root: 'p-0 pt-8' }}>
            <CommentsOverview commentSummary={productionCommentSummary} resource={resource} />
          </TabPanel>
        </TabContext>
      </div>
    </CardContent>
  );
}

export default ContentListItemContentCompressed;
